export const ROUTES = {
  root: '/',
  login: '/login',
  forgotPassword: '/login/forgot',
  acceptInvite: '/auth/invite',

  admins: '/admins',

  dashboard: '/',

  users: '/users',
  userDetail: (id: string) => `/users/${id}`,

  manufacturers: '/manufacturers',
  manufacturerDetail: (id: string) => `/manufacturers/${id}`,

  catalog: '/catalog',
  catalogModeration: '/catalog?status=PENDING_MODERATION',
  productDetail: (id: string) => `/catalog/${id}`,

  buyRequests: '/buy-requests',
  buyRequestDetail: (id: string) => `/buy-requests/${id}`,

  taxonomy: '/taxonomy',
  taxonomyCategories: '/taxonomy/categories',
  taxonomyHsCodes: '/taxonomy/hs-codes',

  carriers: '/carriers',
  audit: '/audit',

  settings: '/settings',
} as const;
